import React from 'react';
import { FormattedMessage } from 'react-intl';
import Icon from '../Icon';
import classes from './styles.module.css';

function Modal({ children, isOpen, onClose, onConfirm, title, isConfirm, values: _values }) {
    if (!isOpen) return null;

    return (
        <div className={classes.ModalWrap}>
            <div className={classes.Size500}>
                <div className={classes.Content}>
                    <div className={classes.Header}>
                        <button className={classes.Close} onClick={onClose}>
                            <Icon icon="close" size="15px" />
                        </button>
                    </div>

                    <div className={classes.Body}>
                        {title && <h3 className={classes.Title}>{title}</h3>}
                        {children}
                    </div>

                    {isConfirm && (
                        <div className={classes.Footer}>
                            <button className={classes.ConfirmBtn} onClick={onConfirm}>
                                <FormattedMessage id="Modal.confirm" defaultMessage="Подтвердить" />
                            </button>
                            <button className={classes.CancelBtn} onClick={onClose}>
                                <FormattedMessage id="Modal.cancel" defaultMessage="Отмена" />
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Modal;



// WEBPACK FOOTER //
// ./src/Components/Utils/Modal/index.js